export class CheckAuthStatus {
  static readonly type = '[Auth] check auth status';
}
export class Login {
  static readonly type = '[Auth] login';
}
export class Logout {
  static readonly type = '[Auth] logout';
}
